import { shallowMount } from "@vue/test-utils";
import TopBar from "@/components/core/TopBar";

describe("TopBar component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(TopBar);
  });

  it("Renders del component TopBar", () => {
    expect(wrapper).toBeDefined();
  });
});
